(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cv-pair-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-pair-selector')) {
    customElements.define('cv-pair-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.select = this.querySelector('select');
        this.panel = this.querySelector('[data-selection]');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-status]');
        this.native = [];
        this.select.addEventListener('change', () => this.update());
        this.button.addEventListener('click', () => this.add());
        this.hidden = false;
      }
      disconnectedCallback() { this.native.forEach(el => el.classList.remove('cv-pair-native-hidden')); }
      update() {
        const option = this.select.selectedOptions[0];
        const selected = Boolean(option.value);
        const info = this.closest('product-info') || this.closest('.product__info-container');
        if (info) this.native = [...info.querySelectorAll('product-form')];
        this.native.forEach(el => el.classList.toggle('cv-pair-native-hidden', selected));
        this.panel.hidden = !selected;
        this.status.textContent = '';
        this.querySelector('[data-cart-link]').hidden = true;
        if (!selected) return;
        this.querySelector('[data-total]').textContent = this.querySelector('[data-total-template]').content.textContent.replace('__PRICE__', option.dataset.price);
        this.panel.querySelector('[data-contents]').textContent = this.querySelector('[data-contents-template]').content.textContent.replace('__CONTENTS__', option.dataset.contents);
        this.panel.querySelector('[data-note]').textContent = option.dataset.note;
      }
      async add() {
        if (this.pending || !this.select.value) return;
        const option = this.select.selectedOptions[0];
        const items = [{id: Number(option.value), quantity: 1}];
        if (option.dataset.fixed !== 'true') items.unshift({id:Number(this.dataset.base), quantity:1});
        this.pending = true;
        this.button.disabled = true;
        this.select.disabled = true;
        this.status.textContent = this.dataset.busy;
        let confirmedFailure = false;
        try {
          const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok || result.status) {
            confirmedFailure = true;
            throw new Error(result.description || this.dataset.stock);
          }
          window.location.assign(this.dataset.root + 'cart');
        } catch (error) {
          this.status.textContent = confirmedFailure ? error.message : this.dataset.error;
          this.querySelector('[data-cart-link]').hidden = false;
          this.pending = false;
          this.button.disabled = false;
          this.select.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
